import {Component, effect, inject} from '@angular/core'
import {Router, RouterOutlet} from '@angular/router'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {FooterComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import version from '../assets/package.json'
import {HeaderComponent} from './components/header/header.component'
import {RoleHelper} from './services/role-helper'

@Component({
  selector: 'spb-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [HeaderComponent, RouterOutlet, FooterComponent]
})
export class AppComponent {
  public version = version.version
  public readonly configService = inject(ConfigService)
  private readonly router = inject(Router)
  private readonly helper = inject(RoleHelper)

  constructor() {
    effect(() => {
      if (this.helper.canShowClassicAndRegistrar()) {
        this.router.navigate(['admin']).then()
      } else if (this.helper.canShowClassic()) {
        this.router.navigate(['admin', 'classic']).then()
      } else if (this.helper.canAdminRegistrar()) {
        this.router.navigate(['admin', 'register']).then()
      } else {
        this.router.navigate(['admin']).then()
      }
    })
  }
}
